/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Dimension_Machine_InterfaceInputs */

const en_directory_agent_readiness_dimension_machine_interface = /** @type {(inputs: Directory_Agent_Readiness_Dimension_Machine_InterfaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machine interface`)
};

const zh_directory_agent_readiness_dimension_machine_interface = /** @type {(inputs: Directory_Agent_Readiness_Dimension_Machine_InterfaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`机器接口`)
};

/**
* | output |
* | --- |
* | "Machine interface" |
*
* @param {Directory_Agent_Readiness_Dimension_Machine_InterfaceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_dimension_machine_interface = /** @type {((inputs?: Directory_Agent_Readiness_Dimension_Machine_InterfaceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Dimension_Machine_InterfaceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_dimension_machine_interface(inputs)
	return zh_directory_agent_readiness_dimension_machine_interface(inputs)
});
export { directory_agent_readiness_dimension_machine_interface as "directory.agent_readiness.dimension.machine_interface" }